import { http } from "@/http/axios.js";

// 获取订单流转历史
export function getTransferHistoryAPI(params) {
  return http({
    url: "/admin/afterSaleOrder/flow/list",
    method: "get",
    params,
  });
}

// 提交订单流转
export function submitTransferAPI(data) {
  return http({
    url: "/admin/afterSaleOrder/flow/add",
    method: "post",
    data,
  });
}

